import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.2_@babel+core@7.28.4_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layouts/public-layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"variable\":\"--font-noto-sans\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"fallback\":[\"system-ui\"]}],\"variableName\":\"notoSans\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/public/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingButton"] */ "/app/src/widgets/floating-button/ui/floating-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/widgets/footer/ui/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClient"] */ "/app/src/widgets/header/ui/header-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTopButton"] */ "/app/src/widgets/scroll-to-top/ui/scroll-to-top-button.tsx");
